<template>
  <div class="flex flex-col flex-grow text-2xl justify-center items-center font-bold text-center">
    <h1>Page not found</h1>
    <p>
      The url <em>"{{ path }}"</em> could not be found.
    </p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {
      path: ''
    }
  },
  created() {
    // Set the route path in the data.
    this.path = this.$route.path
  }
}
</script>
